/*
 * Search ERMOS — overlay de busca sobre a pagina atual (nunca navega ao abrir).
 * Mesma familia visual/comportamental do menu, cart drawer e wishlist drawer:
 * painel translucido com blur, scrim, abrir/fechar com is-open + hidden,
 * ESC/scrim/X fecham, scroll da pagina travado (mesmo lockScroll do cart-drawer.js).
 *
 * Busca em tempo real pela Predictive Search API nativa do Shopify
 * (/search/suggest.json) — sem app, sem dependencia externa.
 * - Gatilho: [data-search-trigger] (a lupa do header; continua sendo um <a> para
 *   /search, entao sem JS o fluxo antigo ainda funciona).
 * - Markup: sections/header.liquid; CSS no mesmo arquivo ({% stylesheet %} e global).
 */
(function () {
  if (window.__ermosSearchInit) return;
  window.__ermosSearchInit = true;

  /* Referências (re)obtidas por bind(): o markup vive na section do header, que o
     Theme Editor pode recriar — ver o listener shopify:section:load no fim do arquivo. */
  var drawer, scrim, trigger, input, clearBtn, results, popular, form, searchUrl;

  var DEBOUNCE_MS = 250;
  var LIMIT = 6;
  var FOCUSABLE = 'a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])';
  var moneyFormat = window.ermosMoneyFormat || 'R$ {{amount_with_comma_separator}}';

  var scrollY = 0;
  var debounceTimer = null;
  var reqId = 0;              /* corrida: so a resposta do ultimo pedido pode renderizar */
  var controller = null;
  var lastQuery = '';

  /* ---------- Scroll lock (mesmo padrao de assets/cart-drawer.js) ---------- */
  function lockScroll() {
    scrollY = window.scrollY || window.pageYOffset || 0;
    document.body.style.position = 'fixed';
    document.body.style.top = -scrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }
  function unlockScroll() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, scrollY);
  }

  /* ---------- Abrir / fechar ---------- */
  function onKeydown(e) {
    if (e.key === 'Escape' || e.key === 'Esc') {
      e.preventDefault();
      close();
      return;
    }
    if (e.key !== 'Tab') return;
    var items = Array.prototype.filter.call(drawer.querySelectorAll(FOCUSABLE), function (el) {
      return el.offsetParent !== null && !el.hasAttribute('hidden');
    });
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function open() {
    if (!drawer.hidden) return;
    lockScroll();
    drawer.hidden = false;
    if (scrim) scrim.hidden = false;
    /* focus sincrono, ainda dentro do gesto do usuario: e o que faz o teclado
       do iOS abrir sozinho. Se for para o proximo frame, o iOS ignora. */
    if (input) { try { input.focus({ preventScroll: true }); } catch (err) { input.focus(); } }
    requestAnimationFrame(function () {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      if (scrim) { scrim.classList.add('is-open'); scrim.setAttribute('aria-hidden', 'false'); }
    });
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    document.addEventListener('keydown', onKeydown);
  }

  function close() {
    if (drawer.hidden) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (scrim) { scrim.classList.remove('is-open'); scrim.setAttribute('aria-hidden', 'true'); }
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    document.removeEventListener('keydown', onKeydown);
    if (input) input.blur();
    clearTimeout(debounceTimer);
    if (controller) { controller.abort(); controller = null; }
    /* destrava já (não no timeout): se outro overlay abrir durante o fade, o lock dele
       não pode ser desfeito por este timer atrasado */
    unlockScroll();
    var closing = drawer;
    setTimeout(function () {
      if (!closing.classList.contains('is-open')) {
        closing.hidden = true;
        if (scrim && !scrim.classList.contains('is-open')) scrim.hidden = true;
      }
    }, 280);
  }

  /* ---------- Helpers de render ---------- */
  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* A Predictive Search devolve o preco como string decimal ("189.90"), nao em centavos. */
  function formatPrice(value) {
    var num = parseFloat(value);
    if (isNaN(num)) return '';
    var parts = num.toFixed(2).split('.');
    var br = moneyFormat.indexOf('comma_separator') !== -1;
    var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, br ? '.' : ',');
    return moneyFormat.replace(/\{\{\s*amount[^}]*\}\}/, intPart + (br ? ',' : '.') + parts[1]);
  }

  function thumb(product) {
    var url = (product.featured_image && product.featured_image.url) || product.image;
    if (!url) return '';
    var sized = String(url).replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2');
    return '<img src="' + esc(sized) + '" alt="" loading="lazy" width="56" height="72">';
  }

  function showPopular() {
    if (popular) popular.hidden = false;
    if (results) { results.hidden = true; results.innerHTML = ''; results.classList.remove('is-loading'); }
  }

  function skeleton() {
    var html = '<span class="search-drawer__label">Produtos</span>';
    for (var i = 0; i < 3; i++) {
      html += '<div class="search-drawer__result search-drawer__result--skeleton" aria-hidden="true">' +
                '<span class="search-drawer__result-media"></span>' +
                '<span class="search-drawer__result-info">' +
                  '<span class="search-drawer__sk search-drawer__sk--name"></span>' +
                  '<span class="search-drawer__sk search-drawer__sk--price"></span>' +
                '</span>' +
              '</div>';
    }
    return html;
  }

  function renderLoading() {
    if (popular) popular.hidden = true;
    if (!results) return;
    results.hidden = false;
    /* Se ja existe lista, apenas esmaece (sem layout shift). Se nao, mostra skeleton. */
    if (results.dataset.hasResults === '1') results.classList.add('is-loading');
    else results.innerHTML = skeleton();
  }

  function renderResults(products, query) {
    if (!results) return;
    if (popular) popular.hidden = true;
    results.hidden = false;
    results.classList.remove('is-loading');

    if (!products.length) {
      results.dataset.hasResults = '0';
      results.innerHTML =
        '<div class="search-drawer__empty">' +
          '<p class="search-drawer__empty-title">Nenhum produto encontrado para &ldquo;' + esc(query) + '&rdquo;.</p>' +
          '<p class="search-drawer__empty-sub">Tente outro termo.</p>' +
        '</div>';
      return;
    }

    results.dataset.hasResults = '1';
    var html = '<span class="search-drawer__label">Produtos</span>';
    products.slice(0, LIMIT).forEach(function (p) {
      html += '<a class="search-drawer__result" href="' + esc(p.url) + '">' +
                '<span class="search-drawer__result-media">' + thumb(p) + '</span>' +
                '<span class="search-drawer__result-info">' +
                  '<span class="search-drawer__result-name">' + esc(p.title) + '</span>' +
                  '<span class="search-drawer__result-price">' + esc(formatPrice(p.price)) + '</span>' +
                '</span>' +
              '</a>';
    });
    html += '<a class="search-drawer__all" href="' + esc(searchUrl) + '?q=' + encodeURIComponent(query) +
            '">Ver todos os resultados para &ldquo;' + esc(query) + '&rdquo;</a>';
    results.innerHTML = html;
  }

  /* ---------- Busca ---------- */
  function run(query) {
    query = (query || '').trim();
    lastQuery = query;
    if (clearBtn) clearBtn.hidden = query.length === 0;

    if (!query) {
      if (controller) { controller.abort(); controller = null; }
      if (results) results.dataset.hasResults = '0';
      showPopular();
      return;
    }

    renderLoading();

    var id = ++reqId;
    if (controller) controller.abort();
    controller = (typeof AbortController === 'function') ? new AbortController() : null;

    var url = searchUrl + '/suggest.json?q=' + encodeURIComponent(query) +
              '&resources[type]=product&resources[limit]=' + LIMIT +
              '&resources[options][unavailable_products]=last';

    fetch(url, controller ? { signal: controller.signal } : undefined)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        /* Descarta respostas obsoletas: se "af" chegar depois de "after", ignora. */
        if (id !== reqId || query !== lastQuery) return;
        var list = (data && data.resources && data.resources.results && data.resources.results.products) || [];
        renderResults(list, query);
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        if (id !== reqId) return;
        renderResults([], query);
      });
  }

  /* ---------- Liga os elementos (idempotente por elemento) ---------- */
  function bind() {
    var el = document.querySelector('[data-search-drawer]');
    if (!el) return;
    if (el.dataset.searchBound === '1') return;
    el.dataset.searchBound = '1';

    drawer = el;
    scrim = document.querySelector('[data-search-scrim]');
    trigger = document.querySelector('[data-search-trigger]');
    input = drawer.querySelector('[data-search-input]');
    clearBtn = drawer.querySelector('[data-search-clear]');
    results = drawer.querySelector('[data-search-results]');
    popular = drawer.querySelector('[data-search-popular]');
    form = drawer.querySelector('[data-search-form]');
    searchUrl = (form && form.getAttribute('action')) || '/search';
    lastQuery = '';

    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
      trigger.addEventListener('click', function (e) {
        e.preventDefault();      /* a lupa continua sendo <a href="/search"> como fallback sem JS */
        open();
      });
    }
    if (scrim) scrim.addEventListener('click', close);
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-search-close]')) close();
    });

    if (input) {
      input.addEventListener('input', function () {
        var value = input.value;
        if (clearBtn) clearBtn.hidden = value.trim().length === 0;
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function () { run(value); }, DEBOUNCE_MS);
      });
    }

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        if (!input) return;
        input.value = '';
        clearBtn.hidden = true;
        clearTimeout(debounceTimer);
        run('');
        input.focus();
      });
    }

    drawer.addEventListener('click', function (e) {
      var pill = e.target.closest('[data-search-term]');
      if (!pill || !input) return;
      var term = pill.getAttribute('data-search-term');
      input.value = term;
      clearTimeout(debounceTimer);
      run(term);            /* pill executa na hora, sem esperar o debounce */
      input.focus();
    });
  }

  bind();
  /* Theme Editor: a section do header foi recriada => liga o novo markup. */
  document.addEventListener('shopify:section:load', bind);
})();
